<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item" style="margin-right: 40px;">
              <div class="label">请求:</div>
              <el-select
                v-model="filter.method"
                size="small"
                class="select"
                placeholder="请选择"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in methodList"
                  :key="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <el-input
                class="input"
                v-model="filter.path"
                placeholder="路径"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <el-input
                class="input"
                v-model="filter.name"
                placeholder="名称"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <el-input
                class="input"
                v-model="filter.group"
                placeholder="API组"
                size="small"
              ></el-input>
            </div>
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
        </div>
        <div style="display: flex;justify-content: flex-start;width: 100%;margin-top: 12px;">
          <div class="btn" @click="addModal('add')">
            + 添加API
          </div>
          <div class="btn import-btn" @click="readApi">
            读取API
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          border
          :header-cell-style="{
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '44px',
          }"
          :row-style="{
            height: '44px',
          }"
        >
          <el-table-column
            prop="path"
            align="center"
            label="API路径"
          ></el-table-column>
          <el-table-column
            prop="group"
            align="center"
            label="API分组"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="API名称"
          ></el-table-column>
          <el-table-column
            prop="method"
            align="center"
            label="请求"
          ></el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            width="180"
          >
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                class="table-btn"
                @click="addModal('edit', scope.row)"
              >
                编辑
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="handleDelete(scope.row.id)"
              >
                删除
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="visible" class="dialog" width="480px" top="10vh">
      <div slot="title" class="dialog-title">
        {{ type === "edit" ? "编辑" : "添加" }}API
      </div>
      <el-form
        ref="form"
        :model="form"
        class="user-form"
        label-width="auto"
        label-position="top"
      >
        <el-form-item
          label="路径:"
          prop="path"
          class="form-item"
          style="width: 100%;"
        >
          <el-input
            size="small"
            placeholder="请输入"
            style="width: 100%"
            v-model="form.path"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="请求:"
          prop="method"
          class="form-item"
          style="width: 100%;"
        >
          <el-select
            v-model="form.method"
            size="small"
            class="select"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in methodList2"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="api分组："
          prop="group"
          class="form-item"
          style="width: 100%;"
        >
          <el-input
            size="small"
            placeholder="请输入"
            style="width: 100%"
            v-model="form.group"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="api名称："
          prop="name"
          class="form-item"
          style="width: 100%;"
        >
          <el-input
            size="small"
            placeholder="请输入"
            style="width: 100%"
            v-model="form.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleAddUser"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'user-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 10, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '权限管理',
        secondTitle: 'api管理'
      },
      list: [],
      filter: {
        // 过滤条件
        name: '',
        path: '',
        method: '',
        group: '',
      },
      methodList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '创建(POST)',
          value: 'POST'
        },
        {
          label: '查看(GET)',
          value: 'GET'
        },
        {
          label: '更新(PUT)',
          value: 'PUT'
        },
        {
          label: '删除(DELETE)',
          value: 'DELETE'
        }
      ],
      methodList2: [
        {
          label: '创建(POST)',
          value: 'POST'
        },
        {
          label: '查看(GET)',
          value: 'GET'
        },
        {
          label: '更新(PUT)',
          value: 'PUT'
        },
        {
          label: '删除(DELETE)',
          value: 'DELETE'
        }
      ],

      form: {
        name: '',
        path: '',
        method: '',
        group: ''
      },
      visible: false,
      type: '',
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    },
    orgStructFormat(val){
        if(!val || !val.length) return;
        let str = '';
        val.forEach(item => {
            str += `${item.companyName}/${item.departmentName}/${item.positionName}; `
        });
        return str;
    }
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    // 获取客户列表
    getList() {
      this.loading++;
      this.httpGet(this.$root.getApiList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    readApi(){
      this.loading++;
      this.httpPost(this.$root.readApi, {}).then(
        (res) => {
          this.loading--;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getList();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addModal(type, rowData = {}) {
      this.type = type;
      this.form = {
        name: '',
        path: '',
        method: '',
        group: ''
      };
      if(type === 'edit'){
        this.form = {
          name: rowData.name,
          path: rowData.path,
          method: rowData.method,
          group: rowData.group,
          id: rowData.id
        };
      }
      this.$refs.form && this.$refs.form.clearValidate();
      this.visible = true;
    },
    // 身份授权
    handleAddUser() {
        this.loading++;
        let url = 'addApi', methods = 'httpPost';
        if(this.type === 'edit') {
          url = 'updateApi';
          methods = 'httpPut'
        };
        this[methods](this.$root[url], this.form).then(
        (res) => {
            this.loading--;
            this.visible = false;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getList();
        },
        (res) => {
            this.loading--;
            this.$message.error(res);
        }
        );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        name: '',
        path: '',
        method: '',
        group: '',
      };
      this.getList();
    },
    handleDelete(id){
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该API吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteApi, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
.struct-select .el-cascader-panel li[aria-haspopup] .el-checkbox{
    display: none !important;
}
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
>>>.el-form-item__label{
  padding: 0;
  height: 30px;
}
>>>.el-cascader-panel{
    background: red
}
.el-form-item{
  margin: 0;
}
.page-box {

  .container {
    padding: 24px;
    .filter-box{
      .filter-item {
        margin-right: 28px;
        .select, .input {
          width: 160px;
        }

        .date-input {
          width: 380px;
        }
      }

      .btn-box {
        margin: 0;
      }
    }
    .content {

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        // margin: 16px 0;
      }

      .import-btn{
        background: #DFE7FF;
        color: #4F7AFC;
        border-color: #DFE7FF;
        margin-left: 12px;
      }

      // // 表格按钮
      // .table-btn {
      //   // width: 65px;
      //   height: 24px;
      //   line-height: 24px;
      //   color: gray3;
      //   font-size: 12px;
      //   margin-right: 8px;
      //   cancel-btn();
      //   padding: 0 8px;
      // }

      .table {
        margin-top: 16px !important;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .dialog-title{
    // height: 56px;
    // background: #FAFAFA;
  }

  .user-form{
    flex-x(space-between);
    padding: 0 12px 20px;
    flex-wrap: wrap;
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
  .wx-box{
    flex-y();
    padding-top: 12px;
    padding-bottom: 45px;
    img{
      width: 185px;
      height: 185px;
    }
    div{
      word(16, #333);
      margin-top: 24px;
      text-align: center;
    }
  }
}
</style>
